module.exports = __webpack_public_path__ + "static/hero-17d741384a57e412d8f85ee5da002a9e.jpg";